export default "__VITE_ASSET__Cl6sQTks__"